export const NODE_TYPES = {
  TRIGGER: 'TRIGGER',
  SWITCH: 'SWITCH',
  SEND_MESSAGE: 'SEND_MESSAGE',
  SEND_MESSAGE_AND_WAIT: 'SEND_MESSAGE_AND_WAIT',
  MAKE_HTTP_REQUEST: 'MAKE_HTTP_REQUEST',
  GENERIC: 'GENERIC',
  PLAY: 'PLAY',
  GATHER_INPUT_ON_CALL: 'GATHER_INPUT_ON_CALL',
  SET_VARIABLE: 'SET_VARIABLE',
  DIAL: 'DIAL',
};

export const OPERATORS = {
  EQUAL: 'EQUAL',
  NOT_EQUAL: 'NOT_EQUAL',
  CONTAINS: 'CONTAINS',
  STARTS_WITH: 'STARTS_WITH',
  ENDS_WITH: 'ENDS_WITH',
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN',
  REGEX: 'REGEX',
  IS_EMPTY: 'IS_EMPTY',
  NOT_EMPTY: 'NOT_EMPTY',
};

/** Human-readable labels for operator dropdown (single source of truth). */
export const OPERATOR_LABELS = {
  [OPERATORS.EQUAL]: 'Equals',
  [OPERATORS.NOT_EQUAL]: 'Not Equals',
  [OPERATORS.CONTAINS]: 'Contains',
  [OPERATORS.STARTS_WITH]: 'Starts With',
  [OPERATORS.ENDS_WITH]: 'Ends With',
  [OPERATORS.GREATER_THAN]: 'Greater Than',
  [OPERATORS.LESS_THAN]: 'Less Than',
  [OPERATORS.REGEX]: 'Matches Regex',
  [OPERATORS.IS_EMPTY]: 'Is Empty',
  [OPERATORS.NOT_EMPTY]: 'Is Not Empty',
};

export const SIGNALS = {
  MATCH: 'MATCH',
  NEXT: 'NEXT',
};

export const COLORS = {
  TRIGGER: { stroke: '#ef4444', bgClass: 'bg-red-500', hex: '#ef4444' },
  INCOMING_MESSAGE: {
    stroke: '#eab308',
    bgClass: 'bg-yellow-500',
    hex: '#eab308',
  },
  FAIL_TIMEOUT: { stroke: '#4b5563', bgClass: 'bg-gray-600', hex: '#4b5563' },
  SUCCESS_MATCH: {
    stroke: '#f97316',
    bgClass: 'bg-orange-500',
    hex: '#f97316',
  },
  NO_MATCH_CRITERIA: {
    stroke: '#6366f1',
    bgClass: 'bg-indigo-500',
    hex: '#6366f1',
  },
  DEFAULT: { stroke: '#a855f7', bgClass: 'bg-purple-500', hex: '#a855f7' },

  MUI_PRIMARY: '#1976d2',
  MUI_WARNING: '#ff9800',
  MUI_SUCCESS: '#43a047',
  MUI_SECONDARY: '#7c4dff',

  HEADER_TRIGGER: '#1976d2',
  HEADER_SWITCH: '#f57c00',
  HEADER_SEND_MESSAGE: '#388e3c',
  HEADER_SEND_MESSAGE_AND_WAIT: '#2e7d32',
  HEADER_HTTP_REQUEST: '#7b1fa2',
  HEADER_DEFAULT: '#757575',

  ICON_TRIGGER: '#bbdefb',
  ICON_SWITCH: '#ffe0b2',
  ICON_SEND_MESSAGE: '#c8e6c9',
  ICON_SEND_MESSAGE_AND_WAIT: '#a5d6a7',
  ICON_HTTP_REQUEST: '#e1bee7',
  ICON_DEFAULT: '#f5f5f5',
};

/** Node type → panel header background (single source of truth). */
export const NODE_HEADER_COLORS = {
  TRIGGER: COLORS.HEADER_TRIGGER,
  SWITCH: COLORS.HEADER_SWITCH,
  SEND_MESSAGE: COLORS.HEADER_SEND_MESSAGE,
  SEND_MESSAGE_AND_WAIT: COLORS.HEADER_SEND_MESSAGE_AND_WAIT,
  MAKE_HTTP_REQUEST: COLORS.HEADER_HTTP_REQUEST,
  PLAY: '#0288d1',
  GATHER_INPUT_ON_CALL: '#0097a7',
  SET_VARIABLE: '#7b1fa2',
  DIAL: '#c2185b',
  GENERIC: COLORS.HEADER_DEFAULT,
};

export const HANDLE_COLOR = '#4b5563';
